import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-tham-dinh-detail-ma-so-co-so-nuoi',
  templateUrl: './plan-tham-dinh-detail-ma-so-co-so-nuoi.component.html',
  styleUrls: ['./plan-tham-dinh-detail-ma-so-co-so-nuoi.component.css']
})
export class PlanThamDinhDetailMaSoCoSoNuoiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
